import React, { ReactElement, useMemo } from 'react';
import ReactSelect from 'react-select';
import { Theme as ThemeType } from '../../theme';
import { useTheme } from 'emotion-theming';
import generateStyles from './generateStyles';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import CreatableSelect from 'react-select/creatable';
import { Box, Flex } from 'rebass';
import StatusDot from '../Status/StatusDot';
import chroma from 'chroma-js';

// Known bug
// github.com/JedWatson/react-select/issues/4094

const sampleOptions = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

export type roundValues =
  | 'combo'
  | 'round'
  | 'rounded-right'
  | 'rounded-left'
  | 'square'
  | undefined;

const withCustomStyles = <T extends JSX.ElementType>(Component: T): T =>
  ((props: any): ReactElement => {
    const theme: ThemeType = useTheme();
    const { round = 'round' } = props;
    const { styles } = props;
    const customStyles = useMemo(
      () => generateStyles(round, theme, styles),
      [round, theme]
    );

    return (
      <Component
        menuPortalTarget={document.body}
        {...props}
        styles={customStyles}
      />
    );
  }) as any;

export const formatDotLabel = (option: {
  label: string;
  color: string;
  value: any;
}) => {
  return (
    <Flex flexDirection="row">
      <Flex title={option.label} flexDirection="row" key={option.value}>
        <StatusDot color={option.color} />
      </Flex>
      <Box ml={1} dangerouslySetInnerHTML={{ __html: option.label }} />
    </Flex>
  );
};

export const formatDotStyles = (styles, { data }) => {
  return {
    ...styles,
    background:
      data.color && data.color.indexOf('gradient') === -1
        ? chroma(data.color).alpha(0.3).hex()
        : undefined,
  };
};

const CustomReactSelect = withCustomStyles(ReactSelect);
const CustomAsyncSelect = withCustomStyles(AsyncSelect);
const CustomAsyncCreatableSelect = withCustomStyles(AsyncCreatableSelect);
const CustomCreatableSelect = withCustomStyles(CreatableSelect);

export { sampleOptions as options };
export default CustomReactSelect;
export { CustomAsyncSelect as AsyncSelect };
export { CustomAsyncCreatableSelect as AsyncCreatableSelect };
export { CustomCreatableSelect as CreatableSelect };
